var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.showHistogram)?_c('DateFilterUI',{ref:"scrapedateFilterUI",attrs:{"sliderWidth":_vm.sliderWidth,"interval":_vm.dateInterval,"range":_vm.dateRange,"dates":_vm.dates,"outerRef":"scrapeDateHistogram"},on:{"value-changed":_vm.onDateRangeChanged,"show-date-overlay":_vm.onShowDateOverlay}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }